// extracted by mini-css-extract-plugin
export default {"pages":"pages_pages__m4puG"};